import { z } from "zod";
import { isImperialUnit } from "@/utils";

/**
 * Ranges are whole kilometres, but the same value shown in miles is fractional
 * (10km = 6.21mi), so imperial operators are validated to 2 decimal places instead.
 */
const rangeSchema = (distanceUnit?: string | null) =>
  isImperialUnit(distanceUnit)
    ? z.coerce.number().min(0).max(99999).step(0.01, "Field must be a maximum of 2 decimal places.")
    : z.coerce.number().min(0).max(99999).step(1, "Field must be a whole number.");

export const createStateRatesFormSchema = (distanceUnit?: string | null) =>
  z.object({
    baseInterval: z.object({
      minimumRange: z.coerce.number(),
      maximumRange: rangeSchema(distanceUnit),
      cost: z.coerce.number().min(0).max(999999999).step(0.01, "Field must be a maximum of 2 decimal places."),
    }),
    intervals: z.array(
      z.object({
        minimumRange: rangeSchema(distanceUnit),
        rate: z.coerce.number().min(0).max(999999999).step(0.01, "Field must be a maximum of 2 decimal places."),
      })
    ),
  });

export const stateRatesFormSchema = createStateRatesFormSchema("km");

export type StateRatesFormData = z.infer<typeof stateRatesFormSchema>;
